<template>
  <v-container class="settings-container">
    <v-row>
      <!-- start: content -->
      <v-col>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                id="client-admin-operation-management--module-id"
                v-model="moduleId"
                variant="solo"
                placeholder="CE module ID"
                density="compact"
                :error-messages="moduleIdErrors"
                required
                @update:model-value="v$.moduleId.$touch()"
                @blur="v$.moduleId.$touch()"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <cs-button
                id="client-admin-operation-management--sync-risk"
                primary
                label="Sync"
                @click="syncRiskCategories"
              ></cs-button>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <!-- end: content -->
    </v-row>
    <cs-form-dialog
      v-model="clientAdminOperationManagementGenericDialogDisplayed"
      body-id="client-admin-risk-category-management-modal--generic-dialog"
      heading="Operation Management"
      :primary-action="{
        label: 'Close',
        eventName: 'primary-click'
      }"
      @primary-click="clientAdminOperationManagementGenericDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        {{ operationGenericDialogMessage }}
      </template>
    </cs-form-dialog>
  </v-container>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { required } from '@vuelidate/validators';
import { mapState } from 'vuex';
import { useVuelidate } from '@vuelidate/core';

export default {
  extends: CSBase,

  setup: () => ({ v$: useVuelidate() }),

  data() {
    return {
      componentKey: 0,
      moduleId: '',
      clientAdminOperationManagementGenericDialogDisplayed: false,
      operationGenericDialogMessage: '',
      operationGenericDialogSuccessMessage: 'Risk category table has been synced.'
    };
  },
  validations() {
    return {
      moduleId: { required }
    };
  },
  computed: {
    ...mapState({
      clientSiteSettingsButtonDiplayed: (state) => state.common.clientSiteSettingsButtonDiplayed,
      operationManagementMenuItemDisplayed: (state) =>
        state.common.operationManagementMenuItemDisplayed
    }),
    moduleIdErrors() {
      const errors = [];
      if (!this.v$.moduleId.$dirty) return errors;
      if (!this.moduleId) {
        errors.push('module ID is required');
      }

      return errors;
    }
  },
  async mounted() {
    const { axiosInstance, eventPluginCommonAdapter, stbApiAdapter } = this.$app;
    const isVendorAuthScheme =
      !!this.$route.query['vendor-sid'] && !!this.$route.query['oauth-signature'];
    if (!isVendorAuthScheme) {
      await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
        query: this.$route.query,
        axiosInstance
      });
    }
    await this.$store.dispatch('common/initClientConfig', {
      queryParam: isVendorAuthScheme ? this.$route.query : {},
      eventPluginCommonAdapter,
      stbApiAdapter
    });
    if (!this.clientSiteSettingsButtonDiplayed || !this.operationManagementMenuItemDisplayed) {
      this.$router.push('/excursions');
    }
  },
  methods: {
    async syncRiskCategories() {
      const independentArgHash = {
        payload: { moduleId: this.moduleId, documentTag: '' },
        store: this.$store
      };
      const governmentArgHash = {
        payload: { moduleId: this.moduleId, documentTag: 'STB government' },
        store: this.$store
      };

      const independentCb =
        await this.$app.stbApiAdapter.postPcgRiskCategorySync(independentArgHash);
      const governmentCb = await this.$app.stbApiAdapter.postPcgRiskCategorySync(governmentArgHash);
      if (independentCb.error || governmentCb.error) {
        const dialogMessage = 'Risk category table cannot be synced. Please try again';
        this.operationGenericDialogMessage = `${dialogMessage}`;
        this.clientAdminOperationManagementGenericDialogDisplayed = true;
      } else {
        this.operationGenericDialogMessage = `${this.operationGenericDialogSuccessMessage}`;
        this.clientAdminOperationManagementGenericDialogDisplayed = true;
      }
    }
  }
};
</script>

<style scoped>
.settings-container {
  width: 100%;
  height: 100%;
  max-width: unset;
  margin: 0;
  padding: 0;
}
.settings-content {
  text-align: left;
  height: 100vh;
}
</style>
